import { useState, useEffect, useRef, useCallback } from 'react';

export interface ImageData {
  src: string;
  alt: string;
}

interface ImageRegistryProps {
  images: ImageData[];
  initialImage: string;
}

export const useImageRegistry = ({ images, initialImage }: ImageRegistryProps) => {
  const index = images.findIndex(img => img.src === initialImage)
  const [registry, setRegistry] = useState<ImageData[]>([]);
  const [currentIndex, setCurrentIndex] = useState(index !== -1 ? index : 0);
  const registryRef = useRef<ImageData[]>([]);

  useEffect(() => {
    if (images.length > 0) {
      setRegistry(images);
      registryRef.current = [...images];
    }
  }, [images]);


  const hasNext = currentIndex < registry.length - 1;
  const hasPrev = currentIndex > 0;

  const next = useCallback(() => {
    if (hasNext) {
      setCurrentIndex(prev => prev + 1);
    }
  }, [hasNext]);

  const prev = useCallback(() => {
    if (hasPrev) {
      setCurrentIndex(prev => prev - 1);
    }
  }, [hasPrev]);

  const currentImg = registry[currentIndex];

  return {
    hasNext,
    hasPrev,
    next,
    prev,
    currentImg
  };
};
